import { EMBED_DEFAULT_WIDTH, EMBED_DEFAULT_HEIGHT } from "@corca/tiptap";

import * as iframelyApi from "../api/iframelyApi";

type EmbedProvider = {
  pattern: RegExp;
  toIframe: (url: URL) => string;
};

const EMBED_PROVIDERS: EmbedProvider[] = [
  {
    pattern: /^https:\/\/(?:us|eu)\.posthog\.com\/embedded\/\w+/,
    toIframe: (url: URL) =>
      `<iframe src="${url.toString()}" frameborder="0" allowfullscreen></iframe>`,
  },
];

type EmbedObject = {
  html: string;
  width: number;
  height: number;
  isRichMedia: boolean;
};

export async function fetchEmbed(uri: string): Promise<EmbedObject> {
  for (const provider of EMBED_PROVIDERS) {
    if (uri.match(provider.pattern)) {
      const url = new URL(uri);
      return {
        html: provider.toIframe(url),
        width: EMBED_DEFAULT_WIDTH,
        height: EMBED_DEFAULT_HEIGHT,
        isRichMedia: true,
      };
    }
  }

  const iframelyEmbed = await iframelyApi.fetchEmbed(
    uri,
    EMBED_DEFAULT_WIDTH,
    EMBED_DEFAULT_HEIGHT,
  );
  return {
    html: iframelyEmbed.html,
    width: iframelyEmbed.width || EMBED_DEFAULT_WIDTH,
    height: iframelyEmbed.height || EMBED_DEFAULT_HEIGHT,
    isRichMedia: iframelyEmbed.medium !== "link",
  };
}
